"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardMLSLogo = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardMLSLogoMixin = require("../../mixins/components/PropertyCardMLSLogoMixin");
var StyledPropertyCardMLSLogo = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardMLSLogo",
  componentId: "c11n-8-107-0__sc-1pf6ff9-0"
})(["", ""], _PropertyCardMLSLogoMixin.PropertyCardMLSLogoMixin);
exports.StyledPropertyCardMLSLogo = StyledPropertyCardMLSLogo;